import BaseError from '../BaseError';

class MissingEventCallbackError extends BaseError {
  constructor(eventName) {
    super(`Please provide event callback (eventName: ${eventName})`);
  }
}

export default MissingEventCallbackError;
